import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function CtaSection() {
  return <section className="px-4 mb-16 text-center" data-id="element-56">
      <div className="bg-card p-8 md:p-10 rounded-3xl shadow-diary border-2 border-forest/10" data-id="element-57">
        <h2 className="font-handwriting text-4xl md:text-5xl font-bold text-forest mb-4" data-id="element-58">
          Lass dein Futter endlich richtig wirken
        </h2>

        <p className="font-serif text-lg text-text/80 mb-8 max-w-md mx-auto" data-id="element-59">
          Mit dem Magen-Darm-Topping holst du mehr aus jedem Napf heraus –
          risikofrei testen.
        </p>

        <div className="mb-6" data-id="element-60">
          <CtaButton label="Hilf auch deinem Hund — natürlich & sanft" position="bottom_cta" className="w-full md:w-auto" data-id="element-61" />
          <p className="text-text/60 text-[13px] italic mt-3 max-w-sm mx-auto" data-id="element-62">
            Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
            Hunderunde-Kunden bestellen regelmäßig nach.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm font-serif text-brown/80" data-id="element-63">
          <div className="flex items-center gap-1.5" data-id="element-64">
            <CheckCircle2 size={16} className="text-forest" data-id="element-65" />
            <span data-id="element-66">Schneller Versand</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-67">
            <CheckCircle2 size={16} className="text-forest" data-id="element-68" />
            <span data-id="element-69">Zufriedenheitsgarantie</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-70">
            <CheckCircle2 size={16} className="text-forest" data-id="element-71" />
            <span data-id="element-72">100% Natürliche Inhaltsstoffe</span>
          </div>
        </div>
      </div>
    </section>;
}